<template>
  <section>
    <!-- Header -->
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-2"></div>
      <div class="col-md-2">
        Target <span class="custom-small">({{ targetDate }})</span>
      </div>
      <div class="col-md-2">
        Initial <span class="custom-small">({{ firstDate }})</span>
        <a href="#measurements" class="custom-info">
          <i
            class="fas fa-info-circle"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            :title="infoText"
            ref="info"
          ></i>
        </a>
      </div>
      <div class="col-md-2">
        Current <span class="custom-small">({{ latestDate }})</span>
      </div>
      <div class="col-md-2">Progress</div>
      <div class="col-md-1"></div>
    </div>
    <!-- Body Weight -->
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-2">Body Weight (lbs)</div>
      <div class="col-md-2">{{ weightTarget }}</div>
      <div class="col-md-2">{{ weightFirst }}</div>
      <div class="col-md-2">{{ weightLatest }}</div>
      <div class="col-md-2">{{ weightProgress }}%</div>
      <div class="col-md-1"></div>
      <!-- </div>
        <div class="row">
          <div class="col-md-2 custom-progress-percent-wrapper">
            <span class="custom-progress-percent">{{ weightProgress }}%</span>
          </div>
          <div class="col-md-10">
            <progress-gauge ref="weightProgress" :progress="weightProgress" />
          </div>
        </div>
      </div> -->
    </div>
    <!-- Body Fat -->
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-2">Body Fat (%)</div>
      <div class="col-md-2">{{ fatTarget }}</div>
      <div class="col-md-2">{{ fatFirst }}</div>
      <div class="col-md-2">{{ fatLatest }}</div>
      <div class="col-md-2">{{ fatProgress }}%</div>
      <div class="col-md-1"></div>
      <!-- <div>
        <div class="row">
          <div class="col-md-2 custom-progress-percent-wrapper">
            <span class="custom-progress-percent">{{ fatProgress }}%</span>
          </div>
          <div class="col-md-10">
            <progress-gauge ref="fatProgress" :progress="fatProgress" />
          </div>
        </div>
      </div> -->
    </div>
    <div class="row mb-2">
      <div class="col-md-1"></div>
      <div class="col-md-11 custom-target-set">{{ lastSetTitle }}</div>
    </div>
    <!-- Ranges -->
    <div class="row">
      <div class="col-md-3 custom-range-label-wrap">
        <span class="custom-range-label">{{ rangeLabel }}</span>
      </div>
      <div class="col-md-6">
        <bodyfat-ranges :ranges="ranges" />
      </div>
      <div class="col-md-3"></div>
    </div>
  </section>
</template>
<script>
import { Tooltip } from 'bootstrap'
import { mapGetters } from 'vuex'
import ProgressGauge from '@/Components/UserCardio/elements/progress-gauge'
import BodyfatRanges from '@/Components/UserCardio/elements/bodyfat-ranges'

export default {
  name: 'bodycomp-measurements2',
  components: {
    ProgressGauge,
    BodyfatRanges,
  },
  data() {
    return {
      infoTip: null,
      infoText: 'To change the "Initial", choose a measurement from below.',
    }
  },
  mounted() {
    this.infoTip = new Tooltip(this.$refs.info)
  },
  computed: {
    ...mapGetters('bodycomposition', ['bodycomposition']),
    ...mapGetters('usercardio', ['member']),
    latestDate() {
      return this.bodycomposition ? this.bodycomposition.measurementDate : null
    },
    targetDate() {
      return this.bodycomposition ? this.bodycomposition.targetLastSet : null
    },
    firstDate() {
      return this.bodycomposition ? this.bodycomposition.firstDateSet : null
    },
    lastSetTitle() {
      return this.bodycomposition
        ? this.bodycomposition.targetLastSetDays
        : null
    },
    weightFirst() {
      return this.bodycomposition
        ? `${parseFloat(this.bodycomposition.firstBodyWeight).toFixed(1)}`
        : null
    },
    weightLatest() {
      return this.bodycomposition
        ? `${parseFloat(this.bodycomposition.bodyWeight).toFixed(1)}`
        : null
    },
    weightTarget() {
      return this.bodycomposition
        ? `${parseFloat(this.bodycomposition.targetBodyWeight).toFixed(1)}`
        : null
    },
    fatFirst() {
      return this.bodycomposition
        ? `${parseFloat(this.bodycomposition.firstBodyFat).toFixed(1)}`
        : null
    },
    fatLatest() {
      return this.bodycomposition
        ? `${parseFloat(this.bodycomposition.bodyFat).toFixed(1)}`
        : null
    },
    fatTarget() {
      return this.bodycomposition
        ? `${parseFloat(this.bodycomposition.targetBodyFat).toFixed(1)}`
        : null
    },
    weightProgress() {
      return this.bodycomposition
        ? parseFloat(this.bodycomposition.weightProgress).toFixed(1)
        : null
    },
    fatProgress() {
      return this.bodycomposition
        ? parseFloat(this.bodycomposition.fatProgress).toFixed(1)
        : null
    },
    rangeLabel() {
      let _label = null
      if (this.bodycomposition) {
        let range = null
        if (this.ranges['Age Range']['1'] === 999) {
          range = `(> 50)`
        } else {
          range = `(${this.ranges['Age Range']['0']} - ${this.ranges['Age Range']['1']})`
        }
        _label = `${this.bodycomposition.gender} ${range}`
      }
      return _label
    },
    ranges() {
      return this.bodycomposition ? this.bodycomposition.bodyfatnorms : null
    },
    weight: {
      get() {
        let _data = 0
        if (this.bodycomposition) {
          _data = this.bodycomposition.targetBodyWeight
          this.targetWeight = this.bodycomposition.targetBodyWeight
        }
        return _data
      },
      set(value) {
        this.targetWeight = value
      },
    },
    fat: {
      get() {
        let _data = 0
        if (this.bodycomposition) {
          _data = this.bodycomposition.targetBodyFat
          this.targetFat = this.bodycomposition.targetBodyFat
        }
        return _data
      },
      set(value) {
        this.targetFat = value
      },
    },
  },
  methods: {
    showInfo(event) {},
    refresh() {
      // this.$refs.weightProgress.refresh()
      // this.$refs.fatProgress.refresh()
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  font-weight: 600;
}
.custom-right {
  text-align: right;
}
.custom-small {
  font-size: 0.8em;
}
.custom-progress-percent-wrapper {
  position: relative;
}
.custom-progress-percent {
  position: absolute;
  right: -35px;
}
.custom-target-set {
  font-weight: 600;
  font-size: 0.9em;
}
.custom-range-label-wrap {
  text-align: right;
  position: relative;
}
.custom-range-label {
  text-align: right;
  font-size: 0.8em;
  top: 28px;
  position: relative;
}
.custom-info {
  cursor: pointer;
  i {
    position: relative;
    top: -8px;
    left: 8px;
    color: #0d6efd;
  }
}
</style>
